import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { api } from "./api";
import { firebaseApi } from "./firebaseApi";
import rootReducer from "./root.reducer";
import { migrations } from "./persistMigrations";
const persistConfig = {
  key: 'root',
  // changes in store update version number too
  version: 3,
  storage,
  whitelist: ['campaignSlice', 'commonSlice', 'dashboardSlice', "wishlistSlice", "communityPostSlice", "campaignByInfluencerSlice"],
  // Merge one level into each slice so keys added to a slice's initialState survive
  // rehydration instead of being dropped by an older persisted blob.
  stateReconciler: autoMergeLevel2,
  migrate: createMigrate(migrations, { debug: false })
}
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware, firebaseApi.middleware),
});

export const persistor = persistStore(store);
setupListeners(store.dispatch);